import { PrinterIcon } from "@heroicons/react/24/solid";

import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import LeasedEquipmentStatus from "./Status";
import LeasedEquipmentType from "./Type";
import LeasedEquipmentMake from "./Make";
import LeasedEquipmentModel from "./Model";
import LeasedEquipmentSupplyAlertProfile from "./SupplyAlertProfile";

export const LeasedEquipmentTabs = [
  {
    to: ROUTE_PATHS.Utilities_LeasedEquipmentConfiguration_Status_Index,
    icon: <PrinterIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Status",
    component: LeasedEquipmentStatus,
    permission: PERMISSIONS.permission_utilities_leasedequipment_status_view,
  },
  {
    to: ROUTE_PATHS.Utilities_LeasedEquipmentConfiguration_Type_Index,
    icon: <PrinterIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Type",
    component: LeasedEquipmentType,
    permission: PERMISSIONS.permission_utilities_leasedequipment_type_view,
  },
  {
    to: ROUTE_PATHS.Utilities_LeasedEquipmentConfiguration_Make_Index,
    icon: <PrinterIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Make",
    component: LeasedEquipmentMake,
    permission: PERMISSIONS.permission_utilities_leasedequipment_make_view,
  },
  {
    to: ROUTE_PATHS.Utilities_LeasedEquipmentConfiguration_Model_Index,
    icon: <PrinterIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Model",
    component: LeasedEquipmentModel,
    permission: PERMISSIONS.permission_utilities_leasedequipment_model_view,
  },
  {
    to: ROUTE_PATHS.Utilities_LeasedEquipmentConfiguration_SupplyAlertProfile_Index,
    icon: <PrinterIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Supply Alert Profile",
    component: LeasedEquipmentSupplyAlertProfile,
    permission: PERMISSIONS.permission_utilities_leasedequipment_supplyalertprofile_view,
  },
];
